import React from 'react'
import { Form } from 'stylist'
import displayName from 'utils/displayName'

const Boolean = ({ field, key }) => (
  <Form.Group key={key}>
    <Form.SwitchInput
      name={field.name}
      label={field.label || `${displayName(field.name)}`}
    />
  </Form.Group>
)

export default Boolean



// WEBPACK FOOTER //
// ./src/components/fields/Boolean.js